import { businessAreasRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { BusinessAreaModel } from '../domain';
import { CreateBusinessAreasJson } from '../types';

export const useCreateBusinessArea = () =>
  useMutation<BusinessAreaModel, unknown, CreateBusinessAreasJson>(
    (createBusinessArea) =>
      businessAreasRepo.createBusinessArea(createBusinessArea),
  );
